<template>
  <div class="home" :style="{minHeight: bodyHeight + 'px'}">
    <gTop />
    <gHead />
    <gNav />
    <div class="gContent" :style="{minHeight: (bodyHeight - 256) + 'px'}">
      <!-- 活动信息 -->
      <div class="m-info" v-if="actDetails">
        <div class="m-info-title">{{actDetails.name}}</div>
        <div class="m-info-brand">
          <div class="brand">
            <i class="icon iconfont icon-tubiao-"></i>
            <span>{{actDetails.regCount}}</span>
          </div>
          <div class="brand">
            <i class="icon iconfont icon-share"></i>
            <span>{{actDetails.shareCount}}</span>
          </div>
          <div class="brand">
            <i class="icon iconfont icon-liuyan4"></i>
            <span>{{actDetails.commentCount}}</span>
          </div>
          <div class="brand">
            <i class="icon iconfont icon-chakan"></i>
            <span>{{actDetails.viewCount}}</span>
          </div>
        </div>
        <div class="m-info-line" v-if="actDetails.address">
          <i class="icon iconfont icon-changyongdizhi" style="color: rgb(209, 49, 25);"></i>
          <span style="padding-left: 0px;">{{actDetails.address}}</span>
        </div>
        <div class="m-info-line">
          <i class="icon iconfont icon-shafa" style="color: #329bba;"></i>
          <span>{{ actDetails.startTime | moment('YYYY/MM/DD') }} ~ {{ actDetails.endTime | moment(' MM/DD') }}</span>
        </div>
      </div>
      <!-- 活动内容 -->

      <div class="main" v-if="actDetails">
        <div class="section">
          <div class="section-top">
            <div class="m-swiper" v-if="imgArr" style="margin-bottom:20px;">
              <!-- 轮播的banner和视频 -->
              <gSwiperCommon3 :list="imgArr" ></gSwiperCommon3>
            </div>
            <!-- 活动介绍 -->
            <div class="m-content" v-if="actDetails.introduction">
              <div v-for="(item,index) in actDetails.introduction" :key="index">
                <!-- 文字 -->
                <p class="int-text" v-if="item.text" style="padding:10px 0;" 
                :style="{'font-size':item.text.fontSize,'color':item.text.color,'text-align':item.text.position}"
                 v-html="item.text.content ? $service.replaceSpeace(item.text.content) : ''"
                >
                </p>
                <!-- 图片 -->
                <div class="int-img" style="font-size:0;" v-if="item.picture && item.picture.type == 1" :style="{'padding-left':item.picture.padding+'px','padding-right':item.picture.padding+'px'}">
                  <div v-for="(itm,idx) in item.picture.list" :key="idx" :style="{'margin-bottom':item.picture.spacing+'px'}">
                    <img :src="itm.url" style="width:100%;" @click="imgLink(itm.link)">
                  </div>
                </div>
                <!-- 轮播图片 -->
                <div class="m-swiper" v-if="item.picture && item.picture.type == 2">
                  <gSwiperCommon2 v-if="companyMsg" :comInfo="companyMsg" :list="item.picture.list"></gSwiperCommon2>
                </div>
                <!-- 视频 -->
                <div class="int-video" v-if="item.video">
                  <video style="width:100%;height:100%;object-fit:fill;" :src="item.video.link" :poster="item.video.cover?item.video.cover:''" controls="controls">
                    您的浏览器不支持video标签
                  </video>
                </div>
              </div>
            </div>
          </div>
          <div class="section-bot">
             <leavingmessage :typeId="actId" :type="'act'" v-if="actId"></leavingmessage>
          </div>
        </div>

        <div class="sidebar" v-if="companyMsg"> 
          <sidebarqrcode :url="url" :showCom="true" :companyMsg="companyMsg"></sidebarqrcode>
        </div>
      </div>
    </div>
    <gBottom />
  </div>
</template>

<script>
import gTop from "@components/En/gTop/gTop.vue";
import gHead from "@components/En/gHead/gHead.vue";
import gNav from "@components/En/gNav/gNav.vue";
import gBottom from "@components/En/gBottom/gBottom.vue";
import gSwiperCommon3 from "@components/En/gSwiperCommon3/gSwiperCommon3.vue"; //轮播图
import gSwiperCommon2 from "@components/En/gSwiperCommon2/gSwiperCommon2.vue"; //轮播图
import leavingmessage from "@components/En/leaving-message"; //留言
import sidebarqrcode from "@components/En/sidebar-QRcode"; //边栏 扫描二维码
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: "activity-details",
  data() {
    return {
      bodyHeight: "800px",
      actId: "",
      imgArr: null,
      compId:"",
      actDetails:null,
      ExVideo:'',
      companyMsg:'', // 公司信息
      url: "",
    };
  },
  components: {
    gTop,
    gHead,
    gNav,
    gBottom,
    gSwiperCommon2,
    gSwiperCommon3,
    leavingmessage,
    sidebarqrcode,
  },
  created() {
    this.init();
  },
  computed: {
    ...mapGetters({
      exhibitionId:'getExhibitionId'
    }),
  },
  methods: {
    ...mapActions({
      getWeAppCode: "exhibitionModule/getWeAppCode"
    }),
    init() {
      this.bodyHeight = window.innerHeight ? window.innerHeight : "800";
      this.actId = this.$router.history.current.params.id;
      this.compId = this.$router.history.current.query.compId;
      this.getActMsg();
      this.getCode();
    },
    async getActMsg(){
      //获取产品详情；
      this.actDetails = await this.$service.getActDetails(this, this.actId);
      if (this.actDetails) {
        if (this.actDetails.introduction.search(/^\[/) !== -1) {
          this.actDetails.introduction = JSON.parse(this.actDetails.introduction);
          this.actDetails.introduction.map(c => {
            if (c.text) {
              c.text.content = c.text.content.replace(/\n/g, "<br/>");
            }
          })
        }
      }
      console.log("活动：",this.actDetails);
      let imgArr = {
        img: [],
        video: {}
      };
      imgArr.img = this.actDetails.banner;
      imgArr.video = this.actDetails.video;
      this.imgArr = imgArr;
      // this.ExVideo = this.actDetails.video.Link;
      // if (this.actDetails.video.Img) {
      //   this.videoCover = this.actDetails.video.Img;
      // } else {
      //   this.videoCover = `${
      //     this.ExVideo
      //   }?x-oss-process=video/snapshot,t_8000,f_jpg,w_590,h_332,m_fast`;
      // }
      this.getCompany();
    },
    async getCompany() {
      // 获取相关公司信息；
      this.$http.get("api/Join/DefaultJoin?compId=" + this.compId, this.$store.state.header).then(res => {
        if (res.status === 200 && res.data) {
          this.companyMsg = res.data;
          console.log(this.companyMsg,'companyMsg')
        }
      });
      // this.companyMsg = await this.$service.getCompanyInfo(this, this.compId);
      // console.log(this.companyMsg,'companyMsg')
    },
    imgLink(e) {
      switch (e.type) {
        case "0": // 自定义
          window.location.href = e.value;
          break;
        case "1": // 公司
          this.$router.push(`/ex-detailsEn/${this.companyMsg.joinId}?exhibitionId=${this.exhibitionId}&compId=${this.compId}`);
          break;
        case "3": // 产品
          this.$router.push(`/pro-detailsEn/${e.value}?compId=${this.compId}`);
          break;
        case "5": // 动态
          this.$router.push(`/chanceEn`);
          break;
      }
    },
    async getCode() {
      let opt = {
        targetType: 3,
        targetId: this.actId,
        scene: this.actId
      }
      let data = await this.getWeAppCode(opt);
      if (data) {
        this.url = data.path;
      }
    },
  } 
};
</script> 

<style scoped lang='scss'>
@import "@assets/scss/utils.scss";
.home {
  background: #f5f5f5;
}
.gContent {
  background: #f5f5f5;
  width: 1200px;
  margin: 20px auto 0;
}
.top-title {
  height: 50px;
  font-size: 14px;
  line-height: 35px;
  &-link {
    color: #999;
  }
}
.main {
  width: 1200px;
  margin-top: 20px;
  margin-bottom: 80px;
  @include clearfix;

  .section {
		width: 878px;
    border-radius: 2px;
    background-color: #fff;
    float: left;
    .section-top{
      padding: 50px 65px;
      box-shadow: 0px 1px 3px 0px rgba(95, 99, 104, 0.1);
    }
    .title {
      min-height: 88px;
      border-bottom: 1px solid #f5f5f5;
    }
    .title div {
      width: 690px;
      margin-left: 94px;
    }
    .title h2 {
      font-size: 24px;
      color: #222222;
      margin-top: 28px;
    }
    .title span {
      font-size: 14px;
      color: #999;
      line-height: 1.5em;
      margin-top: 36px;
    }
    .info {
      margin: 14px 0 28px;
      span {
        margin: 0;
        &:first-child {
          padding-left: 3px;
        }
        padding-left: 10px;
      }
    }
    .swiper .container {
      width: 690px;
      margin: 25px 0 0 94px;
    }
    .container2 {
      width: 690px;
      margin: 25px 0 0 94px;
    }
    .container2 p {
      font-size: 16px;
      color: #222222;
      line-height: 30px;
      margin-top: 40px;
      text-align: justify;
      word-break: break-all;
    }
    .fabulous {
      height: 130px;
      text-align: center;
      margin-top: 50px;
    }
    .fabulous div {
      display: inline-block;
      width: 220px;
      height: 77px;
      border-radius: 38px;
      border: solid 2px #e6e6e6;
      text-align: center;
      line-height: 77px;
      font-size: 20px;
      color: #222222;
      cursor: pointer;
      span {
        position: relative;
        top: -5px;
      }
    }
    .msg {
      margin-left: 94px;
    }
    .more {
      height: 80px;
      text-align: center;
    }
    .more span {
      color: #040000;
      font-size: 14px;
      cursor: pointer;
      line-height: 80px;
    }

    .icon {
      width: 1em;
      height: 1em;
      vertical-align: 0em;
      fill: currentColor;
      overflow: hidden;
      margin-right: 5px;
      font-size: 30px;
    }
  }

  .sidebar {
    width: 300px;
    float: right;
    // @include empty-txt(200px, "加载中...");
  }
}

.m-info {
  height: 160px;
  background-color: #fff;
  padding: 20px;
  margin-top: 28px;
  &-title {
    font-size: 24px;
    font-weight: bold;
    color: #333;
    // margin-bottom: 10px;
  }
  &-brand {
    display: flex;
    align-items: center;
    // margin-bottom: 6px;
    .brand {
      align-items: center;
      display: flex;
      margin-right: 15px;
      color:#999;
      height: 32px;
      span{
        font-size: 16px;
      }
      i{
        font-size: 22px;
      }
      .icon-chakan{
        font-size: 24px;
      }
    }
  }
  &-line {
    margin-right: 10px;
    // margin-bottom: 4px;
    display: flex;
    align-items: center;
    i{
      font-size: 20px;
    }
  }
}
.m-content {
	p {
		padding: 43px 0;
	}
	img {
		width: 100%;
	}
}
.section-bot{
  border-top: 20px solid #f5f5f5;
  width: 100%;
	background-color: #fff;
}
.int-video {
  width: 750px;
  height: 500px;
  margin: 10px 0;
}
</style>